<div class="modal-header border-0 pb-0">
  <h5 class="modal-title fw-bold productos-cemento-modal-title">{{ modalTitle }}</h5>
  <button type="button" class="btn-close" aria-label="Cerrar" (click)="onClose()"></button>
</div>

<form [formGroup]="form" (ngSubmit)="onSave()">
  <div class="modal-body pt-2 pb-1 productos-cemento-modal-body">
    <p class="productos-cemento-modal-leyenda small text-muted mb-2">* Campos obligatorios</p>
    <div class="row g-3">
      <div class="col-md-6 col-lg-5">
        <app-cbb-select
          label="Comuna *"
          [options]="comunasOpciones"
          placeholder="Seleccionar comuna"
          appendTo="body"
          [clearable]="false"
          [searchable]="true"
          formControlName="nombreComuna"
          [mensajeError]="fieldError('nombreComuna')"
        ></app-cbb-select>
      </div>
      <div class="col-md-6 col-lg-4">
        <app-cbb-field
          label="Producto *"
          formControlName="producto"
          [mensajeError]="fieldError('producto')"
        ></app-cbb-field>
      </div>
      <div class="col-md-6 col-lg-3">
        <app-cbb-field
          label="Incoterms *"
          formControlName="incoterms"
          [mensajeError]="fieldError('incoterms')"
        ></app-cbb-field>
      </div>

      <div class="col-12">
        <app-cbb-field
          label="Nombre publicación"
          placeholder="Opcional"
          formControlName="nombrePublicacion"
          [mensajeError]="fieldError('nombrePublicacion')"
        ></app-cbb-field>
      </div>

      <div class="col-md-4 col-lg-3">
        <app-cbb-field
          label="Múltiplo *"
          type="number"
          [min]="72"
          [step]="72"
          placeholder="Múltiplo de 72 (72, 144…)"
          formControlName="multiplo"
          [mensajeError]="fieldError('multiplo')"
        ></app-cbb-field>
      </div>
      <div class="col-md-4 col-lg-3">
        <app-cbb-select
          label="Unidad *"
          [options]="unidadOpciones"
          placeholder="Seleccionar unidad"
          appendTo="body"
          [clearable]="false"
          [searchable]="true"
          formControlName="unidad"
          [mensajeError]="fieldError('unidad')"
        ></app-cbb-select>
      </div>
      <div class="col-md-4 col-lg-3">
        <app-cbb-field
          label="Tipo camión *"
          formControlName="tipoCamion"
          [mensajeError]="fieldError('tipoCamion')"
        ></app-cbb-field>
      </div>

      <div class="col-md-4 col-lg-3">
        <app-cbb-field
          label="SKU (POS 10) *"
          formControlName="skuPos10"
          [mensajeError]="fieldError('skuPos10')"
        ></app-cbb-field>
      </div>
      <div class="col-md-4 col-lg-3">
        <app-cbb-field
          label="SKU POS 20"
          formControlName="skuPos20"
          [mensajeError]="fieldError('skuPos20')"
        ></app-cbb-field>
      </div>
      <div class="col-md-4 col-lg-3">
        <app-cbb-field
          label="SKU POS 30"
          formControlName="skuPos30"
          [mensajeError]="fieldError('skuPos30')"
        ></app-cbb-field>
      </div>

      <div class="col-md-4 col-lg-3">
        <app-cbb-field
          label="Precio sin bruto *"
          type="number"
          [min]="0"
          [step]="1"
          formControlName="precioBruto"
          [mensajeError]="fieldError('precioBruto')"
        ></app-cbb-field>
      </div>
      <div class="col-md-4 col-lg-3">
        <app-cbb-select
          label="Activo *"
          [options]="activoOpciones"
          bindLabel="label"
          bindValue="value"
          appendTo="body"
          [clearable]="false"
          [searchable]="false"
          formControlName="activo"
          [mensajeError]="fieldError('activo')"
        ></app-cbb-select>
      </div>
    </div>
  </div>
  <div class="modal-footer border-0 pt-2 d-flex justify-content-evenly flex-wrap gap-2">
    <app-cbb-button
      *ngIf="isEditMode"
      label="Eliminar"
      color="primary"
      (action)="onDelete()"
      [disabled]="loading"
    ></app-cbb-button>
    <app-cbb-button
      [label]="isEditMode ? 'Guardar' : 'Crear'"
      color="green"
      type="submit"
      [disabled]="loading"
    ></app-cbb-button>
  </div>
</form>
